import { Component, Input, NgZone } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../services/api.service';
import { NotificationService } from '../../../services/notification.service';
declare const google: any;

@Component({
  selector: 'app-location-modal',
  templateUrl: './location-modal.component.html',
  styleUrls: ['./location-modal.component.scss'],
})
export class LocationModalComponent {
  @Input() defaultAddress?: any;

  zoom = 15;
  center: google.maps.LatLngLiteral = { lat: 9.932511, lng: 78.144636 };
  markerPos?: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = { zoomControl: true };

  selectedAddress: string = '';

  geocoder = new google.maps.Geocoder();
  currentPlace: any;

  autocompleteQuery = '';
  autocompleteItems: google.maps.places.AutocompletePrediction[] = [];
  GoogleAutocomplete = new google.maps.places.AutocompleteService();

  constructor(
    public activeModal: NgbActiveModal,
    private zone: NgZone,
    private http: ApiService,
    private notify: NotificationService
  ) {}

  ngOnInit() {
    if (this.defaultAddress) {
      this.geocoder.geocode(
        { address: this.defaultAddress },
        (results, status) => {
          this.zone.run(() => {
            if (status === 'OK' && results && results[0]) {
              const loc = results[0].geometry.location.toJSON();
              this.center = loc;
              this.markerPos = loc;
              this.currentPlace = results[0];
              this.selectedAddress = results[0].formatted_address;
            } else {
              console.warn('Geocode failed', status);
              this.setUserLocation();
            }
          });
        }
      );
    } else {
      this.setUserLocation();
    }
  }

  // Extracted for clarity
  private setUserLocation() {
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        this.zone.run(() => {
          const loc = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          this.center = loc;
          this.markerPos = loc;
          this.reverseGeocode(loc);
        }),
      (err) => {
        console.error('Geolocation error', err);
        this.center = { lat: 9.932511, lng: 78.144636 };
        this.markerPos = this.center;
        this.reverseGeocode(this.center);
      },
      { enableHighAccuracy: true }
    );
  }

  private reverseGeocode(loc: google.maps.LatLngLiteral) {
    this.geocoder.geocode({ location: loc }, (res, status) => {
      this.zone.run(() => {
        if (status === 'OK' && res && res[0]) {
          this.currentPlace = res[0];
          this.selectedAddress = res[0].formatted_address;
        }
      });
    });
  }

  updateSearchResults() {
    if (!this.autocompleteQuery) {
      this.autocompleteItems = [];
      return;
    }

    this.GoogleAutocomplete.getPlacePredictions(
      {
        input: this.autocompleteQuery,
        componentRestrictions: { country: 'in' },
      },
      (predictions, status) => {
        this.zone.run(() => {
          this.autocompleteItems =
            status === google.maps.places.PlacesServiceStatus.OK
              ? predictions!
              : [];
        });
      }
    );
  }

  selectAutocomplete(item) {
    this.autocompleteQuery = item.description;
    this.autocompleteItems = [];

    const placesService = new google.maps.places.PlacesService(
      document.createElement('div')
    );
    placesService.getDetails({ placeId: item.place_id }, (place, status) => {
      if (place.geometry?.location) {
        this.zone.run(() => {
          this.center = place.geometry.location.toJSON();
          this.markerPos = this.center;
          this.currentPlace = place;
          this.selectedAddress = this.currentPlace.formatted_address;
        });
      }
    });
  }

  onMapClick(event) {
    if (event.latLng) {
      const loc = event.latLng.toJSON();
      this.markerPos = loc;
      this.geocoder.geocode({ location: loc }, (results, status) => {
        this.zone.run(() => {
          if (status === 'OK' && results && results[0]) {
            this.currentPlace = results[0];
            this.selectedAddress = this.currentPlace.formatted_address;
          }
        });
      });
    }
  }

  confirm() {
    if (this.markerPos && this.currentPlace) {
      this.activeModal.close({
        coords: this.markerPos,
        place: this.currentPlace,
      });
    }
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
